<nz-badge
  [nzSize]="'small'"
  *ngIf="productslength > 0"
  [nzCount]="productslength"
  [routerLink]="'/external/' + sellerId + '/' + pointId + '/basket'"
>
  <span class="primary-color wh-20" nz-icon nzType="shopping-cart" nzTheme="outline"></span>
</nz-badge>
